module.exports = __webpack_public_path__ + "img/zcy_logo.43d7eae1.png";